var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_18023",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 18023",
    width: 20,
    height: 20,
    fill: "#1891e5",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_57475",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 57475",
    d: "M7.833,9.667A3.333,3.333,0,1,0,4.5,6.333,3.333,3.333,0,0,0,7.833,9.667Zm0-5A1.667,1.667,0,1,1,6.167,6.333,1.667,1.667,0,0,1,7.833,4.667ZM14.5,11.333a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,14.5,11.333ZM14.5,8a.833.833,0,1,1-.833.833A.833.833,0,0,1,14.5,8Zm0,4.167a4.167,4.167,0,0,0-2.55.875A5.833,5.833,0,0,0,2,17.167a.833.833,0,1,0,1.667,0,4.167,4.167,0,0,1,8.333,0,.833.833,0,1,0,1.667,0,5.75,5.75,0,0,0-.717-2.792A2.5,2.5,0,0,1,17,16.333a.833.833,0,1,0,1.667,0A4.167,4.167,0,0,0,14.5,12.167Z",
    transform: "translate(-0.333 -0.5)",
    fill: "#1891e5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d48bacbb.svg";
export { ForwardRef as ReactComponent };